import { useState } from "react";
import { topics } from "@/mocks/guage";

export default function TopicsSection() {
  const [active, setActive] = useState(0);
  const current = topics[active];

  return (
    <section id="topics" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-secondary-700 text-xs md:text-sm font-medium">
              <span className="w-6 h-px bg-secondary-500"></span>
              按口味挑瓜
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl text-foreground-950">主题分类</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              六个分类各自负责一种热闹。点左边切换，右边会告诉你这个分类里都拆些什么。
            </p>

            <div className="mt-7 flex flex-col gap-2">
              {topics.map((topic, index) => (
                <button
                  key={topic.name}
                  type="button"
                  onClick={() => setActive(index)}
                  className={`flex items-center justify-between px-4 py-3.5 rounded-lg border text-left transition-colors cursor-pointer ${
                    active === index
                      ? "bg-secondary-500 border-secondary-500 text-background-50"
                      : "bg-background-100 border-background-200 text-foreground-800 hover:border-secondary-300"
                  }`}
                >
                  <span className="flex items-center gap-3">
                    <i className={`${topic.icon} text-lg`}></i>
                    <span className="text-sm md:text-base font-medium whitespace-nowrap">{topic.name}</span>
                  </span>
                  <span className={`text-xs ${active === index ? "text-background-50/80" : "text-foreground-500"}`}>
                    {topic.count} 篇
                  </span>
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="h-full min-h-[380px] rounded-lg bg-background-100 border border-background-200 p-6 md:p-10 flex flex-col">
              <span className="w-14 h-14 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className={`${current.icon} text-3xl`}></i>
              </span>
              <h3 className="mt-5 font-heading text-3xl md:text-4xl text-foreground-950">{current.name}</h3>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{current.desc}</p>

              <ul className="mt-6 space-y-3">
                {[
                  "事件时间线逐条梳理，先看清再评价",
                  "关键细节逐帧标注，槽点不放过",
                  "结尾附瓜哥一句话总结，直给不绕弯",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm md:text-base text-foreground-700">
                    <span className="mt-1 w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-800 shrink-0">
                      <i className="ri-check-line text-xs"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>

              <div className="mt-auto pt-8 flex flex-wrap items-center gap-3">
                <a
                  href="#roast"
                  className="flex items-center gap-2 px-5 py-3 rounded-md bg-secondary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-secondary-600 transition-colors cursor-pointer"
                >
                  进入「{current.name}」
                  <i className="ri-arrow-right-line"></i>
                </a>
                <span className="text-xs text-foreground-500">累计 {current.count} 篇拆解，每周更新</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}